import { useTranslation } from 'react-i18next';
import { QPerson, QStack } from '@qualio/ui-components';
import { useEventPermissions } from '../../../../hooks';
import { QualityEvent } from '../../../../types';
import { PropertySection } from '../PropertySection';
import { PropertySectionText } from '../PropertySectionText';
import { ManageCollaboratorsButton } from './ManageCollaboratorsButton/ManageCollaboratorsButton';

type ManageCollaboratorsProps = {
  event: QualityEvent;
};

export const ManageCollaborators = ({ event }: ManageCollaboratorsProps) => {
  const { t } = useTranslation();
  const { canManageCollaborators } = useEventPermissions();

  return (
    <PropertySection
      title={t('events.labels.collaborators')}
      action={canManageCollaborators && <ManageCollaboratorsButton event={event} />}
    >
      {event.collaborators.length > 0 ? (
        <QStack spacing={2} mt={1}>
          {event.collaborators.map(({ id, full_name, is_active }) => (
            <QPerson key={id} status="default" fullName={full_name} userIsDeactivated={!is_active} />
          ))}
        </QStack>
      ) : (
        <PropertySectionText>-</PropertySectionText>
      )}
    </PropertySection>
  );
};
